import * as React from "react";

import { Slot } from "@/components/ui/slot";

export function renderAsChild(
  asChild: boolean | undefined,
  children: React.ReactNode,
) {
  if (!asChild) {
    return undefined;
  }

  return <Slot>{children}</Slot>;
}
